import types from './types';

const INITIAL_STATE = {
    orders: {
        "Overall": {
          "TotalBaskets": 0,
          "AverageBasketTotal": .0,
          "BasketsTotal": .0
        },
        "ByDate": [],
        "ByDay": [],
        "ByHour": [],
        "ByStore": [],
        "ByKiosk": [],
        "ByIndividualKiosk": [],
        "IsEatInOrIsTakeaway": [],
        "DbMs": 0
      },
    loading: false
};

const ordersReportReducer = (state = INITIAL_STATE, action) => {
    //console.log("ordersReportReducer: action.type = " + action.type);
    switch(action.type) {
        case types.RECEIVE_ORDERS_STATS: {
            return {
                ...state,
                orders: action.data.orders,
                loading: action.data.loading
            };
        }
        case types.REQUEST_ORDERS_STATS: {
            return {
                ...state,
                loading: action.data.loading
            };
        }
        default:
            return state;
    }
}

export default ordersReportReducer;